export default __webpack_public_path__ + "static/media/sflex_hero_2.278d55ab.png";